// src/constants/hiddenLayupConstants.js

export const hiddenLayupCourseIds = [
  'ASCL_ASCL010_01__Introduction_to_Chinese_Culture',
  'ASCL_ASCL010_03__Introduction_to_Japanese_Culture',
  'COCO_COCO021__What_s_in_Your_Shoebox__Unpacking_Your_Study_Abroad_Experience',
  'CRWT_CRWT010__Introduction_to_Fiction',
  'CRWT_CRWT012__Introduction_to_Poetry',
  'ENGS_ENGS012__Design_Thinking',
  'FILM_FILM021__Film_History_II__1930_60_',
  'FILM_FILM030__Documentary_Videomaking',
  'GEOG_GEOG002_01__Introduction_to_Human_Geography',
  'MATH_MATH030_04__Evolutionary_Game_Theory_and_Applications',
  'MES_MES001_01__Introduction_to_Middle_Eastern_Studies',
  'MUS_MUS018_02__Hip_Hop_in_the_United_States',
  'PHYS001__Understanding_the_Universe__From_Atoms_to_the_Big_Bang__with_Laboratory',
  'SPEE020_01__Public_Speaking',
  'REL001_09__Religion_and_Drugs',
  'REL043__Buddhism_in_America',
  'SOCY_SOCY016__Constructing_Social_Theory',
];
